__turbopack_context__.v({
  "filterSection": "_rd_7G_filterSection",
  "hitsAndSort": "_rd_7G_hitsAndSort",
  "hitsSortGroup": "_rd_7G_hitsSortGroup",
  "mainSection": "_rd_7G_mainSection",
  "numHits": "_rd_7G_numHits",
  "pageContainer": "_rd_7G_pageContainer",
  "searchHitsContainerWrapper": "_rd_7G_searchHitsContainerWrapper",
});
